/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import { __decorate } from "tslib";
import { action, computed, observable } from 'mobx';
const NullIndex = -1;
export class LabelerSelectionStore {
    constructor(configStore) {
        this.isDragging = false;
        this.hoverEnd = NullIndex;
        this.hoverStart = NullIndex;
        this.selectionEnd = NullIndex;
        this.selectionStart = NullIndex;
        this._configStore = configStore;
    }
    get isHovered() {
        return this.hoverStart !== NullIndex || this.hoverEnd !== NullIndex;
    }
    get isSelectionInProgress() {
        return !this._configStore.isSelectionDisabled && (this.selectionStart !== NullIndex || this.selectionEnd !== NullIndex);
    }
    initialize(lineCount, tokenCount) {
        this.lineCount = lineCount;
        this.tokenCount = tokenCount;
    }
    hover(tokenIndex) {
        if (this._configStore.isSelectionDisabled) {
            return;
        }
        if (!this.isSelectionInProgress) {
            this.hoverStart = tokenIndex;
        }
        else if (tokenIndex < this.selectionStart) {
            this.hoverStart = tokenIndex;
        }
        else {
            this.hoverEnd = tokenIndex;
        }
    }
    unHover() {
        this.hoverStart = NullIndex;
        this.hoverEnd = NullIndex;
    }
    select(tokenIndex) {
        if (this._configStore.isSelectionDisabled) {
            return;
        }
        if (!this.isSelectionInProgress) {
            this.selectionStart = tokenIndex;
            this.selectionEnd = tokenIndex;
        }
        else if (tokenIndex < this.selectionStart) {
            this.selectionStart = tokenIndex;
        }
        else {
            this.selectionEnd = tokenIndex;
        }
    }
    selectAll() {
        if (this._configStore.isSelectionDisabled) {
            return;
        }
        this.selectionStart = 0;
        this.selectionEnd = this.tokenCount - 1;
    }
    cancelSelection() {
        this.selectionStart = NullIndex;
        this.selectionEnd = NullIndex;
        this.isDragging = false;
    }
    setIsDragging(isDragging) {
        if (this._configStore.isSelectionDisabled) {
            return;
        }
        this.isDragging = isDragging;
    }
}
__decorate([
    observable
], LabelerSelectionStore.prototype, "hoverEnd", void 0);
__decorate([
    observable
], LabelerSelectionStore.prototype, "hoverStart", void 0);
__decorate([
    observable
], LabelerSelectionStore.prototype, "isDragging", void 0);
__decorate([
    observable
], LabelerSelectionStore.prototype, "selectionEnd", void 0);
__decorate([
    observable
], LabelerSelectionStore.prototype, "selectionStart", void 0);
__decorate([
    computed
], LabelerSelectionStore.prototype, "isHovered", null);
__decorate([
    computed
], LabelerSelectionStore.prototype, "isSelectionInProgress", null);
__decorate([
    action
], LabelerSelectionStore.prototype, "initialize", null);
__decorate([
    action
], LabelerSelectionStore.prototype, "hover", null);
__decorate([
    action
], LabelerSelectionStore.prototype, "unHover", null);
__decorate([
    action
], LabelerSelectionStore.prototype, "select", null);
__decorate([
    action
], LabelerSelectionStore.prototype, "selectAll", null);
__decorate([
    action
], LabelerSelectionStore.prototype, "cancelSelection", null);
__decorate([
    action
], LabelerSelectionStore.prototype, "setIsDragging", null);
